import { NullAnalyticsProvider } from './NullAnalyticsProvider';
import { BoostAnalyticsProvider } from '../platforms/boost/analytics';
import AppConfig from '../config/config';
/**
 * Factory mirroring `src/search/providers.ts`. Keyed off `AppConfig.provider`
 * so the analytics implementation tracks the configured search provider.
 *
 * Adding a new analytics implementation: implement `AnalyticsProvider` in
 * `src/platforms/<name>/analytics/<Name>AnalyticsProvider.ts`, then add a
 * branch here. The call sites never change.
 */
export function getAnalyticsProvider(providerType) {
    const provider = providerType || AppConfig.provider;
    switch (provider) {
        case 'boost':
            return new BoostAnalyticsProvider();
        // Other platforms can ship their own analytics impls in the future:
        //   case 'algolia': return new AlgoliaAnalyticsProvider();
        //   case 'unbxd':   return new UnbxdAnalyticsProvider();
        // For now, anything else falls back to the no-op provider so call sites
        // stay platform-agnostic.
        default:
            return new NullAnalyticsProvider();
    }
}
